import { ResourcePoolImpl } from './ResourcePoolImpl';
import { ShaderSourceResource } from './ShaderSourceResource';

export class ShaderSourceResourcePool extends ResourcePoolImpl<ShaderSourceResource, string> {
  createResource(resourceId: string): ShaderSourceResource {
    return new ShaderSourceResource(resourceId);
  }

  loadData(data: string): string {
    return data;
  }
}
